
export const metaNoticeStyles = (theme: ThemeType) => ({
  color: theme.palette.lwTertiary.main,
  fontSize: "1rem",
  marginLeft: 4,
  ...theme.typography.italic,
});
